import cx from "classnames"
import PropTypes from "prop-types"
import Image from "components/ui/Image"

function FeaturesList({ className, children }) {
  return (
    <ul
      className={cx(
        className,
        "grid grid-cols-1 gap-y-9 gap-x-20 lg:grid-cols-2 xl:gap-x-32"
      )}
    >
      {children}
    </ul>
  )
}

FeaturesList.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** List content */
  children: PropTypes.node,
}

export function ListItem({ image, title, description, size, center }) {
  return (
    <li
      className={cx(
        "flex flex-col gap-x-8 md:flex-row xl:gap-x-14",
        center ? "items-center" : "items-start"
      )}
    >
      <Image
        className={cx(
          "w-36 flex-shrink-0",
          size === "large" ? "md:w-32" : "md:w-28"
        )}
        src={image}
        objectFit="contain"
      />
      <div className={cx({ "md:pt-5": !center })}>
        <h4 className="text-2xl font-bold">{title}</h4>
        {description && (
          <p className="mt-1 text-base leading-snug text-dark-grey">
            {description}
          </p>
        )}
      </div>
    </li>
  )
}

ListItem.propTypes = {
  /** Item illustration */
  image: PropTypes.shape({}),
  /** Item title */
  title: PropTypes.string,
  /** Item description */
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Item illustration size */
  size: PropTypes.oneOf(["regular", "large"]),
  /** If true, horizontally center content */
  center: PropTypes.bool,
}

export default FeaturesList
